module.exports = __webpack_public_path__ + "img/ASNBANK.d818f0ee.jpg";